<template>
  <v-container>
    <v-fade-transition mode="out-in">
      <a-authorization-card
        v-if="email"
        class="ma-5"
        color="secondary"
        icon="mdi-check"
        title="Activation de votre compte"
      >
        <p>
          Vous pouvez dorénavant vous connecter à votre espace
          <router-link to="/accueil"> Associations Alsace-Moselle </router-link> avec votre adresse courriel
          {{ email }}.
        </p>
      </a-authorization-card>
      <template v-else>
        <a-authorization-card
          v-if="!erreur"
          class="ma-5"
          color="secondary"
          icon="mdi-arrow-decision"
          title="Finalisation de la connexion"
          text="Récupération des informations d'authentification en cours."
          sub="Cela peut prendre quelques instants."
        />
        <a-authorization-card
          v-else
          class="ma-5"
          color="error"
          icon="mdi-account-alert-outline"
          title="Erreur lors de l'authentification"
          text="Oups... quelque chose s'est mal passé lors de votre authentification."
          sub="Si vous avez déjà suivi ce lien, veuillez ignorer ce message et vous connecter normalement."
        />
      </template>
    </v-fade-transition>
  </v-container>
</template>

<script>
import { oauth2Service, principalService } from "@/services";
import makeFields from "@/mixins/makeFields";

export default {
  data() {
    return {
      erreur: false,
      email: null,
    };
  },

  computed: {
    ...makeFields({ redirectTo: "login/redirectTo" }),
  },

  mounted() {
    const url = window.location.search;

    //suppression des paramètres state et code de l'URL
    window.history.replaceState({}, {}, "/accueil");

    oauth2Service
      .processVerificationUrl(url)
      .then(() => principalService.principal())
      .then(principal => {
        const { email } = principal;
        oauth2Service.logout();
        this.email = email;
      })
      .catch(() => {
        this.erreur = true;
        oauth2Service.logout();
      });
  },
};
</script>
